import Vue from 'vue';

// USED to send events between components
// Shoutout to https://appdividend.com/2018/06/03/how-to-create-a-global-event-bus-with-vue-js/

export const EventBus = new Vue();
